import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogTrigger,
} from "./ui/dialog";
import { Check, Loader2 } from "lucide-react";

const ROLES = ["Artist", "Venue", "Listener"];

const encodeForm = (data) =>
  Object.keys(data)
    .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`)
    .join("&");

export default function WaitlistDialog({ trigger }) {
  const [open, setOpen] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("Artist");
  const [status, setStatus] = useState("idle"); // idle | loading | done | error
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    if (!name.trim() || !email.trim()) {
      setErr("Please add your name and email.");
      return;
    }
    setStatus("loading");
    try {
      await fetch("/", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: encodeForm({
          "form-name": "waitlist",
          name: name.trim(),
          email: email.trim(),
          role,
        }),
      });
      setStatus("done");
    } catch (e2) {
      setErr("Something went wrong. Please try again.");
      setStatus("error");
    }
  };

  const reset = () => {
    setName("");
    setEmail("");
    setRole("Artist");
    setStatus("idle");
    setErr("");
  };

  return (
    <Dialog
      open={open}
      onOpenChange={(v) => {
        setOpen(v);
        if (!v) setTimeout(reset, 250);
      }}
    >
      <DialogTrigger asChild>{trigger}</DialogTrigger>
      <DialogContent className="wl-dialog">
        {status === "done" ? (
          <div className="wl-success">
            <div className="wl-check">
              <Check size={22} strokeWidth={2} />
            </div>
            <DialogTitle className="wl-title">You're on the list.</DialogTitle>
            <DialogDescription className="wl-desc">
              Thanks, {name.split(" ")[0] || "friend"}. We'll be in touch as Soundie opens up.
            </DialogDescription>
          </div>
        ) : (
          <>
            <DialogHeader>
              <DialogTitle className="wl-title">Join the waitlist</DialogTitle>
              <DialogDescription className="wl-desc">
                Be first to know when Soundie opens in your city.
              </DialogDescription>
            </DialogHeader>
            <form
              className="wl-form"
              onSubmit={submit}
              name="waitlist"
              data-netlify="true"
            >
              <label className="wl-field">
                <span>Name</span>
                <input
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder="Your name"
                  autoComplete="name"
                />
              </label>
              <label className="wl-field">
                <span>Email</span>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="you@email.com"
                  autoComplete="email"
                />
              </label>
              <div className="wl-field">
                <span>I'm a…</span>
                <div className="wl-roles">
                  {ROLES.map((r) => (
                    <button
                      type="button"
                      key={r}
                      className={`wl-role ${role === r ? "active" : ""}`}
                      onClick={() => setRole(r)}
                    >
                      {r}
                    </button>
                  ))}
                </div>
              </div>
              {err ? <p className="wl-error">{err}</p> : null}
              <button className="wl-submit" type="submit" disabled={status === "loading"}>
                {status === "loading" ? (
                  <>
                    <Loader2 size={15} className="wl-spin" /> Joining…
                  </>
                ) : (
                  <>Request access &rarr;</>
                )}
              </button>
            </form>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
}
